import { useState, useEffect, useContext } from "react";

import {
  EditIcon1,
  SearchIcon,
  DoubleTickIcon,
  SimpleTickIcon,
  PlusCircle,
} from "../kits/Icons.tsx";
import profileImage from "../../assets/images/profileImage.jpg";
import useWindowSize from "../../hooks/useWindowSize";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import { searchFunc } from "../../utils/helperFunction.jsx";
import AddEditCustomerModal from "../customer-list/customerModal/AddEditCustomerModal.jsx";
import useAxios from "../../services/useAxios";
import { translateToReactSelect } from "../../utils/helperFunction.jsx";
import { TimeStampToJalali } from "../../utils/helperFunction.jsx";
export default function ContactsList({
  contacts,
  setContacts,
  contactsSearch,
  setContactsSearch,
  setChatboxShow,
  setContactBoxShow,
  selectedContact,
  setSelectedContact,
  timer,
  tagOption,
  userOption,
  bankName,
  tagUpdater,
  setTagUpdater,
  setLoadingChat,
  sendMsgFunction = () => {},
  searchContact,
  setSearchContact,
  scrollToBottom,
}) {
  const { userInfo } = useContext(AuthenticationContext);
  const winSize = useWindowSize();
  const [activeContact, setActiveContact] = useState("-1");
  // add customer modal
  const [showCustomerModal, setShowCustomerModal] = useState(false);

  useEffect(() => {
    let temp = searchFunc(searchContact, contacts);
    setContactsSearch(temp);
  }, [searchContact]);
  return (
    <>
      <div
        className="pt-1"
        style={{
          position: "sticky",
          backgroundColor: "white",
          zIndex: 100,
          width: "100%",
          top: -5,
          borderTopRightRadius: "13px",
          borderBottom: "1px solid navy",
        }}
      >
        {" "}
        <div className="d-flex justify-content-between mt-4">
          {/* <div className="d-flex ">
          <div className="mx-3">
            <img
              src={profileImage}
              style={{ width: 50, height: 50, borderRadius: "50%" }}
            />
          </div>
          <div>
            <h5 className="text-purple fw-bold">{userInfo.fullName}</h5>
            <h6 className="text-gray fs-14 mt-2">برنامه نویس فرانت</h6>
          </div>
        </div> */}
          <div
            className="mx-3 cursor-pointer d-flex align-items-center p-2 rounded rounded-3 border"
            style={{ backgroundColor: "rgb(212 212 226)" }}
            onClick={() => setShowCustomerModal(true)}
          >
            <PlusCircle color="gray" width={16} height={16} />
            <span className="ms-2" style={{ fontSize: 13 }}>
              {" "}
              افزودن مشتری
            </span>
          </div>
        </div>
        <div className="my-4 mx-3">
          <div className="position-relative ">
            <input
              placeholder="جستجوی مخاطبین"
              type="text"
              className="form-control border-0"
              value={searchContact}
              onChange={(e) => setSearchContact(e.target.value)}
              style={{
                height: "40px",
                paddingRight: "40px",
                borderRadius: "25px",
                backgroundColor: "#eee",
              }}
            />
            <SearchIcon
              color="gray"
              style={{ position: "absolute", top: 9, right: 6 }}
            />
          </div>
        </div>
      </div>

      <div className="mb-3" style={{ height: (winSize.height * 60) / 100 }}>
        {contactsSearch.map((value, index) => {
          return (
            <div>
              <div
                className="d-flex justify-content-between p-3 contactlist-style rounded"
                style={{
                  cursor: "pointer",
                  //backgroundColor: activeContact == index && "rgb(228 228 245)",
                  backgroundColor:
                    selectedContact.id == value.id && "rgb(228 228 245)",
                }}
                onClick={() => {
                  if (selectedContact.id != value.id) {
                    setLoadingChat(true);
                  }
                  setSelectedContact(value);
                  setActiveContact(index);
                  winSize.width < 700 && setChatboxShow(true);
                  winSize.width < 700 && setContactBoxShow(false);
                  // scrollToBottom();
                }}
              >
                <div className="d-flex">
                  <div className="img-profile">
                    <img
                      src={profileImage}
                      className="w-100 h-100"
                      // style={{ width: 40, height: 40, borderRadius: "50%" }}
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <div className="mx-2">
                    <h6 className="fw-bold text-purple one-line">
                      {value.fullname}
                    </h6>
                    <h6
                      className="mt-2 fs-12 one-line"
                      style={{ color: "#b8b7b7" }}
                    >
                      {value.lastMessage}
                    </h6>
                  </div>
                </div>
                <div className="ms-2 text-end">
                  <div className="fs-14">{value.time}</div>
                  {value.newMessage == true ? (
                    <div
                      style={{
                        backgroundColor: "#0f0f78",
                        maxWidth: "25px",
                      }}
                      className="text-white text-center mt-2 pt-1 fs-12 rounded"
                    >
                      {value.newMessageNumber}
                    </div>
                  ) : (
                    <div>
                      <DoubleTickIcon
                        color="green"
                        style={{ width: 20, height: 20 }}
                      />
                      {/* <SimpleTickIcon
                        color="gray"
                        style={{ width: 20, height: 20 }}
                      /> */}
                    </div>
                  )}
                  {value?.reminder_end_tm != 0 &&
                    value?.reminder_end_tm != undefined && (
                      <div style={{ fontSize: 10, color: "red" }}>
                        {TimeStampToJalali(
                          parseInt(value.reminder_end_tm) * 1000,
                          "YYYY/MM/DD"
                        )}
                      </div>
                    )}
                </div>
              </div>
              {index != contacts.length - 1 && (
                <hr
                  className="line"
                  style={{ width: "82%", margin: 0, marginRight: "auto" }}
                />
              )}
            </div>
          );
        })}
      </div>
      <div>
        <AddEditCustomerModal
          type="add"
          headerText="افزودن مشتری"
          show={showCustomerModal}
          setShow={setShowCustomerModal}
          tagOption={tagOption}
          userOption={userOption}
          bankName={bankName}
          setCustomerUpdater={() => {}}
          setTagUpdater={setTagUpdater}
        />
      </div>
    </>
  );
}
